export default __webpack_public_path__ + "static/media/uefa-icon.908ad4b4.svg";